/** ClickUp 14zf25zkw26. Fleet-wide activity summary for the admin dashboard.
 *  Flags compare unrounded ratios against these thresholds. */
export const INACTIVE_MAX_TRACKED_RATIO = 0.5;
export const LOW_PRODUCTIVITY_MAX_RATIO = 0.6;
export const NEEDS_CLASSIFICATION_MIN_UNDEFINED_RATIO = 0.2;
export const ACTIVITY_SUMMARY_MAX_DAYS = 31;
export const ACTIVITY_SUMMARY_EARLIEST_DATE = '2026-10-05';
export const ACTIVITY_SUMMARY_PRESETS = ['latest', '7d', '30d'];
//# sourceMappingURL=activity-summary.js.map